import { useStore } from '@nanostores/react';
import { useEffect, useState } from 'react';
import { Button } from '~/components/ui/Button';
import { redirectToPersonalBillingPage } from '~/lib/stores/pricing/helpers';
import { proPricingPlansStore } from '~/lib/stores/pricing/proPlans';
import { teamPricingPlansStore } from '~/lib/stores/pricing/teamPlans';
import { userStore } from '~/lib/stores/user';
import { redirectToOrgBillingPage } from '~/utils/subscription';
import { withSpinner } from '~/utils/withSpinner';

export const PaymentRenewalBanner = () => {
  const user = useStore(userStore.user);
  const activeOrganization = useStore(userStore.getActiveOrganization());

  const [showPaymentRenewalBanner, setShowPaymentRenewalBanner] = useState(false);
  const [showManageSubscritionButtons, setShowManageSubscritionButtons] = useState(false);
  const [isCancelingSubscription, setIsCancelingSubscription] = useState(false);
  const [paymentAlertDismissed, setPaymentAlertDismissed] = useState(false);

  useEffect(() => {
    setShowPaymentRenewalBanner(false);
    setShowManageSubscritionButtons(false);

    if (activeOrganization) {
      if (!!activeOrganization.billing && !activeOrganization.billing.paid) {
        setShowPaymentRenewalBanner(true);

        if (activeOrganization.role === 'admin') {
          setShowManageSubscritionButtons(true);
        }
      }
    } else if (user?.membership?.subscription?.status === 'past_due') {
      setShowPaymentRenewalBanner(true);
      setShowManageSubscritionButtons(true);
    }
  }, [user, activeOrganization]);

  function redirectToBillingPage() {
    if (activeOrganization) {
      redirectToOrgBillingPage(activeOrganization);
    } else {
      redirectToPersonalBillingPage();
    }
  }

  function cancelSubscription() {
    withSpinner({
      action: async () => {
        if (activeOrganization) {
          await teamPricingPlansStore.cancelSubscription();
        } else {
          await proPricingPlansStore.cancelSubscription();
        }
      },
      onStateUpdate: setIsCancelingSubscription,
    });
  }

  return (
    <>
      {!paymentAlertDismissed && showPaymentRenewalBanner && (
        <div className="flex items-start gap-3 p-4 bg-bolt-ds-warningContainer border border-bolt-ds-warningOutline rounded-lg">
          <div className="i-ph:warning text-bolt-ds-warning text-lg shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-bolt-elements-textWarning font-semibold text-sm mb-1 mt-0.5">
              We couldn't renew your subscription
            </h3>
            <p className="text-bolt-elements-textSecondary text-sm mb-2">
              Your recent payment couldn't be processed, so your account has been temporarily moved to the Free plan
              with a daily token limit. <br />
              Don't worry – your data is safe and accessible. Simply update your payment details to restore access to
              all paid features and remove the daily limit. We'll retry payment automatically over the next few days.
            </p>
            <div className="flex items-center gap-3">
              {showManageSubscritionButtons && (
                <div className="flex items-center gap-3">
                  <Button variant="secondary" size="sm" onClick={redirectToBillingPage}>
                    Update payment method
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={cancelSubscription}
                    disabled={isCancelingSubscription}
                    loading={isCancelingSubscription}
                  >
                    Stay on free tier
                  </Button>
                </div>
              )}
              <Button variant="ghost" size="sm" onClick={() => setPaymentAlertDismissed(true)}>
                I understand, dismiss alert
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
